import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "text-end" }

import { useRoute } from 'vue-router';
import { ref, defineAsyncComponent, onMounted, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { error_message, success_message } from '@/components/common/toast';
import ApiServices from '@/services/apiServices';
import { useLoaderState } from '@/store/loading';
import type { notification } from '@/core/data/notification';
import {
    notificationTopic,
    shortNotificationTopic,
} from '@/core/data/notificationTopic';

export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationEdit',
  setup(__props) {

let route = useRoute();
const { t } = useI18n();
const NotificationEdit = defineAsyncComponent(
    () => import('@/components/theme/notification/NotificationEdit.vue'),
);
const notificationTopics = ref<shortNotificationTopic[]>([]);

let notification = ref<notification>({
    id: undefined,
    title: '',
    body: '',
    topic: undefined,
    type: 'INFORMATION',
    createdBy: undefined,
    createdAt: new Date(),
    updatedBy: undefined,
    updatedAt: new Date(),
    status: undefined,
});

const title = computed(() => {
    return notification.value && notification.value.id
        ? t('notificationEdit.updatetitle')
        : t('notificationEdit.createtitle');
});
const save = async () => {
    if (!notification.value.title) {
        error_message(t('notificationEdit.titleRequired'));
        return;
    }
    const bodyText = notification.value.body?.replace(/<[^>]*>/g, '').trim();
    if (!bodyText) {
        error_message(t('notificationEdit.bodyRequired'));
        return;
    }
    useLoaderState().changeStateTrue();
    if (route.query.email !== undefined) {
        //@ts-ignore
        ApiServices.update(
            'notificationTypes',
            notification.value,
            notification.value.id,
        )
            .then(() => {
                success_message(t('notificationEdit.updated'));
            })
            .catch((ex) => {
                error_message(ex);
            })
            .finally(() => {
                useLoaderState().changeStateFalse();
            });
    } else {
        ApiServices.create('notifications', notification.value)
            .then(() => {
                success_message(t('notificationEdit.saved'));
            })
            .catch((ex) => {
                error_message(ex);
            })
            .finally(() => {
                useLoaderState().changeStateFalse();
            });
    }
};
const getDatas = async () => {
    if (route.query.id !== undefined) {
        ApiServices.getById('notifications', route.query.id.toString()).then(
            (response: any) => {
                notification.value = response;
            },
        );
    }
};
const getNotificationTopics = async () => {
    ApiServices.getAll('notificationTypes', {}, ['_id', 'title', 'key'], {
        page: 1,
        rowsPerPage: 50,
        title: 'title',
        descending: true,
    }).then((response: any) => {
        if (response?.entries && response?.entries.length > 0) {
            response?.entries.forEach((topic: notificationTopic) => {
                notificationTopics.value.push({
                    id: topic.id,
                    title: topic.title,
                    key: topic.key,
                });
            });
        }
        if (
            notificationTopics.value &&
            notificationTopics.value.length > 0 &&
            notification.value.topic === undefined
        ) {
            notification.value.topic = notificationTopics.value[0];
        }
    });
};
onMounted(() => {
    useLoaderState().changeStateTrue();
    getDatas();
    getNotificationTopics();
    useLoaderState().changeStateFalse();
});

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_Card3 = _resolveComponent("Card3")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Notification",
      mains: title.value,
      title: "Accueil"
    }, null, 8, ["mains"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Card3, { colClass: "col-sm-12" }, {
          default: _withCtx(() => [
            _createVNode(_unref(NotificationEdit), {
              notification: _unref(notification),
              notificationTopics: notificationTopics.value
            }, null, 8, ["notification", "notificationTopics"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("a", {
                    class: "btn btn-success me-1",
                    target: "_blank",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (save()))
                  }, _toDisplayString(_ctx.$t('save')), 1)
                ])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})